import React from "react";
import { Outlet } from "react-router";

export default function AuthLayout() {
  return (
    <article>
      <Outlet />
    </article>
  );
}
